import React from 'react';

import { Box } from '@chakra-ui/react';
import { colorOpacity } from 'theme';

import { WithResourceIcon } from 'components/DataDisplay';
import { IconType } from 'components/Icons';

export const renderDetailsFieldWithIcon = (
  iconType: IconType,
  label: any,
  color: string | undefined,
) => {
  return (
    <Box display="inline-block">
      <WithResourceIcon
        resourceType={iconType}
        useCustomColor
        bgColor={colorOpacity(color, 0.2)}
        color={color}
        spacing={2}
      >
        {label}
      </WithResourceIcon>
    </Box>
  );
};

// Sub-header for multi-entity exceptions, e.g. "2 entities in Prod, 1 account".
// Missing lists count as 0 and a missing environment is left out (it used to
// read "undefined").
export const getMultiEntitySubHeader = (
  aggregatedAlert: Record<string, any> | undefined,
  environmentName?: string,
) => {
  const entities = aggregatedAlert?.entity_id_list?.length ?? 0;
  const accounts = aggregatedAlert?.account_id_list?.length ?? 0;
  return (
    `${entities} ${entities === 1 ? 'entity' : 'entities'}` +
    (environmentName ? ` in ${environmentName}` : '') +
    `, ${accounts} account${accounts === 1 ? '' : 's'}`
  );
};

// "Name (cloud id)" for an account, falling back to its id when unknown.
export const formatAccountName = (
  account: Record<string, any> | undefined,
  accountId: string,
) => (account ? `${account.name} (${account.cloud_account_id})` : accountId);

// "Env (Name - cloud id)" for a single account; parts that are unknown are
// replaced by the account id or left out instead of showing "undefined".
export const formatEnvironmentAccount = (
  environmentName: string | undefined,
  account: Record<string, any> | undefined,
  accountId: string | undefined,
) => {
  const accountLabel = account
    ? `${account.name} - ${account.cloud_account_id}`
    : accountId ?? '-';
  return environmentName
    ? `${environmentName} (${accountLabel})`
    : accountLabel;
};
